const translationMapping = {
  existingUser: [
    {
      title: 'Gifting just got easier',
      desc: (
        <>
          We’ve made gifting easier by <b>simplifying</b> the gift-sending experience into two
          streamlined features: <b>recognitions</b> and <b>automations.</b>
        </>
      )
    },
    {
      title: 'Your journey starts with recognitions',
      desc: (
        <>
          Send a <b>test gift</b> by completing this <b>5-minute tour,</b> which will walk you
          through the essential steps of creating a <b>recognition</b> – the perfect way to send
          single or bulk gift orders to recipients for any occasion.
        </>
      )
    }
  ]
};

export { translationMapping };
